import React from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { FormControl, Input, InputAdornment } from '@mui/material'
import { Search } from '@mui/icons-material'
import { muiOptions, MuiProps } from '../../../infrastructure/materialUiThemeProvider'

type SearchFieldStyleProps = {
    root?
}

type SearchFieldProps = {
    label?: string
    text: string
    overrideStyle?: SearchFieldStyleProps
    disableNewStyle?: boolean
    expandHorizontally?: boolean
    onClick?: () => void
    onChange: (e) => void
}

function _SearchField({ label, text, onChange, classes, onClick, overrideStyle, disableNewStyle, expandHorizontally }: SearchFieldProps & MuiProps) {
    let valueText = text != null ? text : ''
    let variant = !disableNewStyle ? { variant: 'filled' } as any : {}
    return (
        <FormControl {...variant}
            classes={{ root: overrideStyle?.root }} className={[classes.minForm, ...(expandHorizontally ? [classes.expand] : [classes.maxForm])].join(' ')}>
            <Input
                className={'searchbar'}
                placeholder={label}
                value={valueText}
                onKeyDown={onChange}
                onChange={onChange}
                startAdornment={
                    <InputAdornment position='start'>
                        <Search
                            style={{
                                cursor: onClick
                                    ? 'pointer'
                                    : 'arrow',
                                marginBottom: '0.5em',
                                width: '0.8em',
                                height: '0.8em'
                            }}
                            onClick={onClick} />
                    </InputAdornment>} />
        </FormControl>
    )
}

let styles = theme =>
    createStyles({
        maxForm: {
            maxWidth: '15.3em',
        },
        minForm: {
            minWidth: '5.3em'
        },
        expand: {
            flexGrow: 1
        },
    })

export let SearchField = withStyles(styles, muiOptions)(_SearchField)